<!-- 创建服务群弹窗 -->
<template>
  <Dialog
    :visible="visible"
    position="bottom"
    @update:visible="e => (visible = e)"
  >
    <div class="create-service-group-dialog">
      <div class="create-service-group-dialog__title">请选择服务人员</div>
      <Loading :loading="loading">
        <div class="create-service-group-dialog__content">
          <div
            v-for="item in groupList"
            :key="item.id"
            :class="[
              'create-service-group-dialog__content__item',
              selectedGroup && selectedGroup.id === item.id ? 'create-service-group-dialog__content__item--selected' : '',
              !item.employees.length ? 'create-service-group-dialog__content__item--disabled' : ''
            ]"
            @click="() => handleSelectGroup(item)"
          >
            <div style="flex: 1;">
              <div class="create-service-group-dialog__content__item__name">{{ item.name }}</div>
              <div v-if="item.employees.length" class="create-service-group-dialog__content__item__members">{{ item.employees.map(v => v.name).join('&nbsp;&nbsp;') }}</div>
            </div>
            <div class="create-service-group-dialog__content__item__check">
              <MaterialSymbolsCheck style="color: #fff;" />
            </div>
          </div>
          <div v-if="!groupList.length" class="create-service-group-dialog__content__empty">未设置售后分组，请进入DOS系统配置</div>
        </div>
      </Loading>
      <x-button type="primary" :disabled="!selectedGroup || loadingSubmit" @click="handleCreateServiceGroup">
        <div style="display: flex; align-items: center;justify-content: center;gap: 5px;">
          <LoadingIcon v-if="loadingSubmit" />
          <span>创建服务群</span>
        </div>
      </x-button>
    </div>
  </Dialog>
</template>

<script>
import LoadingIcon from '@/components/Loading/LoadingIcon.vue'
import MaterialSymbolsCheck from '@/components/icons/MaterialSymbolsCheck.vue'
import Loading from '@/components/Loading/Index.vue'
import Dialog from '@/components/Dialog/Index.vue'
import { XButton } from '@lx-frontend/cvux'

import { mapActions } from 'vuex'

export default {
  name: 'CreateServiceGroupDialog',
  components: {
    Dialog,
    XButton,
    LoadingIcon,
    Loading,
    MaterialSymbolsCheck
  },
  data() {
    return {
      visible: false,
      loading: false,
      groupList: [],
      selectedGroup: null,
      loadingSubmit: false,
      userInfo: {},
      externalUserId: ''
    }
  },
  mounted() {
    this.$wechat.promise.then(async wx => {
      this.externalUserId = await wx.getCurExternalUserId()
    })
  },
  watch: {
    visible(val) {
      !val && this.$emit('cancel')
    }
  },
  methods: {
    ...mapActions('aftersales', ['GET_USERINFO_BY_EXID']),
    open(userInfo) {
      this.visible = true
      this.userInfo = userInfo
      !this.groupList.length && this.getServiceGroupList()
    },
    async getServiceGroupList() {
      if (this.loading) return
      try {
        this.loading = true
        const res = await this.$rest.aftersales.getServiceGroupList()
        if (res.code) return (this.groupList = [])
        const _groupList = []
        const _noMemberGroupList = []
        res.data.teams.forEach(item => {
          if (item.employees.length) {
            _groupList.push(item)
          } else {
            _noMemberGroupList.push(item)
          }
        })
        this.groupList = [..._groupList, ..._noMemberGroupList]
      } finally {
        this.loading = false
      }
    },
    handleSelectGroup(item) {
      if (this.loadingSubmit) return
      if (!item.employees.length) return
      this.selectedGroup = item
    },
    /**
     * 检查外部联系人是否已绑定服务群
     */
    async checkExternalUserBindGroup() {
      const res = await this.GET_USERINFO_BY_EXID(this.externalUserId)
      return !!res.chatid
    },
    async handleCreateServiceGroup() {
      if (this.loadingSubmit) return
      try {
        this.loadingSubmit = true
        // 算上自己和客户不能超过40人
        if (this.selectedGroup.employees.length > 38) return this.showToast('人数太多，无法创建群聊')

        if (await this.checkExternalUserBindGroup()) return this.showToast('该客户已经关联车主服务群，不可新建服务群')

        const userIds = this.selectedGroup.employees.map(v => v.corp_user_id).filter(v => !!v)

        const groupName = `${this.userInfo.name} ${this.userInfo.vin} 专属服务群`

        // PC 上打开新会话会导致页面直接关闭，无法保证 openEnterpriseChat 之后提交群ID的请求发出
        // 需要提前提交信息，后端收到企微回调后再绑定
        const res = await this.$rest.aftersales.preBindOwnerServiceGroup({
          chat_name: groupName,
          external_userid: this.externalUserId
        })
        if (res.code) return this.showToast(res.message)

        /**
         * @see https://developer.work.weixin.qq.com/document/path/96930
         */
        await new Promise((resolve, reject) => wx.openEnterpriseChat({
          groupName,
          userIds: userIds.join(';'),
          externalUserIds: this.externalUserId,
          fail: (res) => {
            this.showToast('创建失败:' + res.errMsg)
            console.log('openEnterpriseChat fail', res)
            reject(res)
          },
          success: function(res) {
            resolve()
            console.log('openEnterpriseChat success', res)
          }
        }))

        this.visible = false
        this.showToast('创建成功')
        // 上报群ID
      } finally {
        this.loadingSubmit = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../stylesheets/base/fn.less";

.create-service-group-dialog {
  padding: 30/@w2;
  .gap-y(30/@w2);

  &__title {
    font-size: 34/@w2;
    line-height: 48/@w2;
    font-weight: 600;
    color: #1F2023;
    padding-bottom: 10/@w2;
  }
  &__content {
    max-height: 60vh;
    overflow-y: auto;
    .gap-y(20/@w2);

    &__item {
      border: 1px solid #F7F8FB;
      border-radius: 16/@w2;
      padding: 30/@w2;
      transition: all 0.2s;
      position: relative;
      cursor: pointer;
      background: #F7F8FB;
      display: flex;
      .gap-x(20/@w2);
      align-items: center;
      box-sizing: border-box;

      &--selected {
        border-color: #217BFF;

        .create-service-group-dialog__content__item__check {
          border-color: #217BFF;
          background: #217BFF;
          color: #fff;
        }
      }
      &--disabled {
        opacity: 0.5;
        color: #999;
        cursor: not-allowed;
      }

      &__name {
        font-size: 30/@w2;
        line-height: 42/@w2;
        font-weight: 600;
        color: #1F2023;
      }
      &__members {
        font-size: 30/@w2;
        line-height: 42/@w2;
        padding-top: 10/@w2;
        color: #80838E;
        word-break: break-all;
      }
      &__check {
        width: 36/@w2;
        height: 36/@w2;
        min-width: 36/@w2;
        background: transparent;
        border: 1px solid #989EA9;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s;
        font-size: 24/@w2;
      }
    }

    &__empty {
      text-align: center;
      color: #989EA9;
      padding: 12vh 0;
      font-size: 30/@w2;
    }
  }

  /deep/ .weui_btn {
    min-height: 100/@w2;
    font-size: 30/@w2;
    border-radius: 5/@w2;

    &:disabled {
      opacity: 0.4;
    }
  }
}
</style>
